import React from 'react'
import '../styles/About.css'
import Timeline from './Timeline'
export default function About({ ref }) {
    return (
        <section className="about" ref={ref} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out-quad">
            <h2 className='right' >
                <div>
                    <span className='beautify'>01. </span>About me
                </div>
            </h2>
            <div className="container">
                <p>
                    I'm Rishabh Singh, a backend-leaning full-stack developer from Varanasi, India.
                </p>

                <p>
                    I enjoy building scalable backend systems, optimizing performance, and working across the stack when needed.
                    During my internships, I improved database performance by <strong>35%</strong>, reduced API load times by <strong>29%</strong>, and built secure,
                    production-ready systems using <strong>Django, DRF, Node.js, React, Docker, PostgreSQL, Redis</strong>, and more.
                </p>

                <p>
                    I love solving engineering problems, whether it's profiling SQL queries, designing reliable APIs, optimizing caching layers,
                    or shipping containerized microservices. I’m also passionate about open-source and have contributed patches to
                    <strong> XFCE (Thunar)</strong> and <strong>Inkscape</strong>, fixing bugs and improving performance in systems written in C/C++.
                </p>

                <p>
                    Beyond coding, I’m an eternal learner who enjoys exploring computer networks, system design, and distributed systems.
                </p>
            </div>
            <div className="timeline">
                <Timeline />
            </div>
        </section>
    )
}
